/**
 * Converts a UTC string to a human-readable date in the format DD/MM/YYYY
 * @param {string} utcString - The UTC string to be converted
 * @returns {string} The human-readable date in the format DD/MM/YYYY
 */
export function ISOStringToDMY(utcString:string) {
    try {
        if (!utcString) {
            return '';
        }
        const date = new Date(utcString);
        // Extract each part
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        
        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    } catch(err) {
        console.error(err);
        return '';
    }
}

/**
 * Capitalize the first letter of a string
 * @param string 
 * @returns 
 */
export function capitalizeFirstLetter(string:string) {
    return String(string).charAt(0).toUpperCase() + String(string).toLowerCase().slice(1);
}